var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"news-commentary","category-name":"時事解説"}})}
var staticRenderFns = []

export { render, staticRenderFns }